import React from 'react';
import './EmptyState.css';

interface EmptyStateProps {
  icon?: 'target' | 'rocket' | 'star' | 'inbox' | 'search';
  title: string;
  subtitle?: string;
  actionLabel?: string;
  onAction?: () => void;
}

const icons: Record<string, React.ReactNode> = {
  target: (
    <svg className="empty-state__svg" viewBox="0 0 120 120" fill="none">
      <circle className="empty-state__ring empty-state__ring--1" cx="60" cy="60" r="50" stroke="#e2e8f0" strokeWidth="2" />
      <circle className="empty-state__ring empty-state__ring--2" cx="60" cy="60" r="35" stroke="#a7f3d0" strokeWidth="2" />
      <circle className="empty-state__ring empty-state__ring--3" cx="60" cy="60" r="20" stroke="#0d9488" strokeWidth="2.5" />
      <circle className="empty-state__dot" cx="60" cy="60" r="6" fill="#0d9488" />
      <line className="empty-state__arrow" x1="60" y1="2" x2="60" y2="20" stroke="#0d9488" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  rocket: (
    <svg className="empty-state__svg" viewBox="0 0 120 120" fill="none">
      <path className="empty-state__rocket" d="M60 20 C60 20 45 45 45 70 C45 85 55 90 60 90 C65 90 75 85 75 70 C75 45 60 20 60 20Z" fill="#0d9488" opacity="0.15" stroke="#0d9488" strokeWidth="2" />
      <circle className="empty-state__flame empty-state__flame--1" cx="55" cy="92" r="4" fill="#f59e0b" />
      <circle className="empty-state__flame empty-state__flame--2" cx="60" cy="96" r="5" fill="#ef4444" />
      <circle className="empty-state__flame empty-state__flame--3" cx="65" cy="92" r="4" fill="#f59e0b" />
      <circle cx="60" cy="50" r="6" fill="#fff" stroke="#0d9488" strokeWidth="2" />
    </svg>
  ),
  star: (
    <svg className="empty-state__svg" viewBox="0 0 120 120" fill="none">
      <path className="empty-state__star" d="M60 15 L70 45 L102 45 L76 63 L86 95 L60 77 L34 95 L44 63 L18 45 L50 45Z" fill="#fbbf24" opacity="0.15" stroke="#f59e0b" strokeWidth="2" />
      <circle className="empty-state__sparkle empty-state__sparkle--1" cx="95" cy="25" r="3" fill="#f59e0b" />
      <circle className="empty-state__sparkle empty-state__sparkle--2" cx="25" cy="30" r="2" fill="#0d9488" />
      <circle className="empty-state__sparkle empty-state__sparkle--3" cx="100" cy="80" r="2.5" fill="#8b5cf6" />
    </svg>
  ),
  inbox: (
    <svg className="empty-state__svg" viewBox="0 0 120 120" fill="none">
      <rect className="empty-state__box" x="25" y="35" width="70" height="55" rx="8" fill="#f1f5f9" stroke="#cbd5e1" strokeWidth="2" />
      <path className="empty-state__flap" d="M25 55 L60 75 L95 55" stroke="#94a3b8" strokeWidth="2" fill="none" />
      <circle className="empty-state__zzz empty-state__zzz--1" cx="75" cy="30" r="0" fill="#94a3b8" />
      <circle className="empty-state__zzz empty-state__zzz--2" cx="85" cy="22" r="0" fill="#94a3b8" />
    </svg>
  ),
  search: (
    <svg className="empty-state__svg" viewBox="0 0 120 120" fill="none">
      <circle className="empty-state__lens" cx="52" cy="52" r="28" stroke="#cbd5e1" strokeWidth="3" fill="#f8fafc" />
      <line className="empty-state__handle" x1="72" y1="72" x2="98" y2="98" stroke="#94a3b8" strokeWidth="4" strokeLinecap="round" />
      <circle className="empty-state__glint" cx="42" cy="42" r="4" fill="#e2e8f0" />
    </svg>
  ),
};

const EmptyState: React.FC<EmptyStateProps> = ({ icon = 'target', title, subtitle, actionLabel, onAction }) => (
  <div className="empty-state">
    <div className="empty-state__icon">{icons[icon]}</div>
    <h3 className="empty-state__title">{title}</h3>
    {subtitle && <p className="empty-state__subtitle">{subtitle}</p>}
    {actionLabel && onAction && (
      <button className="empty-state__action" onClick={onAction}>{actionLabel}</button>
    )}
  </div>
);

export default EmptyState;
